var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-list"},[_c('v-row',[_c('v-col',{staticClass:"d-flex align-center justify-start py-5 empty-list-line"},[_c('PtrIcon',{attrs:{"icon":"alert-icon"}}),_vm._v(" "+_vm._s(_vm.message))],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }